import { writable } from 'svelte/store';
import {dismissToast, toasts} from "./Toasts";

export const modal_box = writable({ open: false, title: '', text: '', html: '', type: '', inputs: [], buttons: []});

function isHTML(str) {
    let doc = new DOMParser().parseFromString(str, "text/html");
    return [].slice.call(doc.body.childNodes).some(node => node.nodeType === 1);
}

export const alert = (title=null, message=null, options={}) => {
    let m_o = true;
    modal_box.update(o => {
        let text = '';
        let html = '';
        if (isHTML) html = message;
        else text = message;

        let button_label = 'Fermer';
        if ("button" in options && "label" in options.button) button_label = options.button.label;
        let button_color = 'secondary';
        if ("button" in options && "color" in options.button) button_color = options.button.color;
        let button_cb = null;
        if ("button" in options && "callback" in options.button) button_cb = options.button.callback;
        return {
            open: true,
            title: title ?? '',
            text: text ?? '',
            html: html ?? '',
            type: 'alert',
            inputs: [],
            buttons: [
                {
                    label: button_label,
                    color: button_color,
                    callback: () => {
                        modal_box.update(oo => {
                            return {
                                open: false,
                                title: '',
                                text: '',
                                html: '',
                                type: '',
                                inputs: [],
                                buttons: []
                            }
                        });
                        if (typeof button_cb === "function") button_cb();
                    }
                }
            ]
        }
    });
    return new Promise(waitForAlertClose); // set the promise object within the ensureFooIsSet object

    function waitForAlertClose(resolve, reject) {
        if (!m_o)
            resolve(true);
        else
            setTimeout(waitForAlertClose.bind(this, resolve, reject), 30);
    }
}

export const confirm = async (title=null, message=null, callback=null, options={}) => {
    let returned_val = null;
    let m_o = true;
    modal_box.update(o => {
        let text = '';
        let html = '';
        if (isHTML) html = message;
        else text = message;

        let button_yes_label = 'Oui';
        if ("buttons" in options && "yes" in options.buttons && "label" in options.buttons.yes) button_yes_label = options.button.label.yes;
        let button_no_label = 'Non';
        if ("buttons" in options && "no" in options.buttons && "label" in options.buttons.no) button_no_label = options.button.label.no;

        let button_yes_color = 'primary';
        if ("buttons" in options && "yes" in options.buttons && "color" in options.buttons.yes) button_yes_color = options.buttons.yes.color;
        let button_no_color = 'secondary';
        if ("buttons" in options && "no" in options.buttons && "color" in options.buttons.no) button_no_color = options.buttons.no.color;

        let button_yes_cb = null;
        let button_no_cb = null;
        if (typeof callback === "function") {
            button_yes_cb = callback;
            button_no_cb = callback;
        }
        if ("buttons" in options && "yes" in buttons && "callback" in options.buttons.yes) button_yes_cb = options.buttons.yes.callback;
        if ("buttons" in options && "no" in buttons && "callback" in options.buttons.no) button_no_cb = options.buttons.no.callback;

        return {
            open: true,
            title: title ?? '',
            text: text ?? '',
            html: html ?? '',
            type: 'alert',
            inputs: [],
            buttons: [
                {
                    label: button_no_label,
                    color: button_no_color,
                    callback: () => {
                        modal_box.update(oo => {
                            return {
                                open: false,
                                title: '',
                                text: '',
                                html: '',
                                type: '',
                                inputs: [],
                                buttons: []
                            }
                        });
                        if (typeof button_no_cb === "function") {
                            button_no_cb(false);
                        }
                        returned_val = false;
                        m_o = false;
                    }
                },
                {
                    label: button_yes_label,
                    color: button_yes_color,
                    callback: () => {
                        modal_box.update(oo => {
                            return {
                                open: false,
                                title: '',
                                text: '',
                                html: '',
                                type: '',
                                inputs: [],
                                buttons: []
                            }
                        });
                        if (typeof button_yes_cb === "function") {
                            button_yes_cb(true);
                        }
                        returned_val = true;
                        m_o = false;
                    }
                }
            ]
        }
    });
    return new Promise(waitForConfirmClose); // set the promise object within the ensureFooIsSet object

    function waitForConfirmClose(resolve, reject) {
        if (!m_o)
            resolve(returned_val);
        else
            setTimeout(waitForConfirmClose.bind(this, resolve, reject), 30);
    }
}

export const close = function() {
    modal_box.update(o => {
        let oo = {...o};
        oo.open = false;
        return oo;
    });
}